<div><app-dashboard-header></app-dashboard-header></div>

<div>
  <mat-sidenav-container class='app-drawer-container ' autosize style=" padding-top:30px ;">
    <mat-sidenav class="closeMobView" #sidenav mode="side" opened *ngIf="currentRout != '/playersHomePage'">
      <app-side-nav></app-side-nav>
    </mat-sidenav>
    <mat-sidenav-content class="mat_SideNavContent">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
